import { Action, State, StateContext, Store } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { SignalRActions } from './signalr.actions';

export interface SignalRStateModel {
  connectionId: string;
}

const defaults = {
  connectionId: String,
};

@State<SignalRStateModel>({
  name: 'signalR',
  defaults: {
    connectionId: '',
  },
})
@Injectable()
export class SignalRState {
  constructor() {}

  @Action(SignalRActions.SetConnectionId)
  setConnectionId(
    ctx: StateContext<SignalRStateModel>,
    { connectionId }: SignalRActions.SetConnectionId
  ) {
    ctx.patchState({ connectionId: connectionId });
  }
}
